<form (ngSubmit)="$event.preventDefault(); saveNotification();" [formGroup]="notificationForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
    <div class="w-full overflow-y-auto px-1">
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Notifications
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4">

            <div *ngFor="let item of checklist" class="w-full flex flex-col gap-2">
                <div class="w-full flex items-center">
                    <input [id]="item.formControlName" [formControlName]="item.formControlName" type="checkbox"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500focus:ring-2">
                    <label [for]="item.formControlName" class="ms-2 font-semibold">
                        {{ item.label }}
                    </label>
                </div>

                <div *ngIf="notificationForm.get(item.formControlName)?.value" class="pl-4 flex flex-col gap-2">

                    <div *ngIf="notificationForm.get(item.selector + '_informed')" class="w-full flex flex-col gap-2">
                        <div class="w-full flex items-center gap-2">
                          <input
                            [id]="item.selector + '-informed-yes'"
                            type="radio"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                            [value]="yesNo.Yes"
                            [formControlName]="item.selector + '_informed'"
                          />
                          <label [for]="item.selector + '-informed-yes'" class="font-medium">has been informed</label>
                        </div>
                      
                        <div class="w-full flex items-center gap-2">
                          <input
                            [id]="item.selector + '-informed-no'"
                            type="radio"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                            [value]="yesNo.No"
                            [formControlName]="item.selector + '_informed'"
                          />
                          <label [for]="item.selector + '-informed-no'" class="font-medium">needs to be informed</label>
                        </div>
                      </div>
                      

                    <div *ngIf="notificationForm.get(item.selector + '_informed')?.value === yesNo.Yes"
                        class="w-full flex flex-col gap-2">
                        <div class="w-full flex flex-col items-start text-start">
                            <div class="w-full font-semibold">
                                <p>By Whom: *</p>
                            </div>
                            <div class="w-full flex flex-col items-center">
                                <input type="text" [formControlName]="item.selector + '_informant'"
                                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                    placeholder="Type here">
                            </div>
                        </div>
                        <div class="w-full flex flex-col items-start text-start">
                            <div class="w-full font-semibold">
                                <p>On: *</p>
                            </div>
                            <div class="w-full flex items-center gap-2">
                                <div class="relative">
                                    <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                        <svg class="w-4 h-4 text-gray-500" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                            <path
                                                d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                                        </svg>
                                    </div>
                                    <input #datepickerRef [attr.data-selector]="item.selector"  [id]="'datepicker-' + item.selector" type="text"
                                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="notificationForm.get(item.selector + '_informed')?.value === yesNo.No"
                        class="w-full flex flex-col items-start text-start">
                        <div class="w-full font-semibold">
                            <p>Planning Notes:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea [formControlName]="item.selector + '_informed_notes'" rows="3"
                                class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>

                    <div *ngIf="item.formControlName === 'staff_teachers_notification'"
                        class="w-full flex flex-col items-start text-start">
                        <div class="w-full font-semibold">
                            <p>Planning Notes:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea [formControlName]="item.selector + '_informed_notes'" rows="3"
                                class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                placeholder="Type here..."></textarea>
                        </div>
                    </div>


                </div>


            </div>



            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Does this section require one or more assigned responsibilities to manage and support in the
                        ROAR? *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="notifications_roar_needed_yes" value="{{ yesNo.Yes }}"
                            class="hidden peer" formControlName="notifications_roar_needed">
                        <label for="notifications_roar_needed_yes"
                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="notifications_roar_needed_no" value="{{ yesNo.No }}" class="hidden peer"
                            formControlName="notifications_roar_needed">
                        <label for="notifications_roar_needed_no"
                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <!-- <button type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.notificationForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.notificationForm.valid
                }" [disabled]="this.notificationForm.invalid">
                Save
            </button> -->

            <button type="submit"
                [disabled]="!isAnyCheckboxChecked() || notificationForm.invalid"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isAnyCheckboxChecked() || notificationForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isAnyCheckboxChecked() && notificationForm.valid
                }">
                Save
            </button>
        </div>
    </div>
</form>